import dotRed from 'components/icons/svg/mapDotRed.svg';
import dotRedPositive from 'components/icons/svg/mapDotRedPositive.svg';
import dotRedNeutral from 'components/icons/svg/mapDotRedNeutral.svg';
import dotRedNegative from 'components/icons/svg/mapDotRedNegative.svg';
import dotYellow from 'components/icons/svg/mapDotYellow.svg';
import dotYellowPositive from 'components/icons/svg/mapDotYellowPositive.svg';
import dotYellowNeutral from 'components/icons/svg/mapDotYellowNeutral.svg';
import dotYellowNegative from 'components/icons/svg/mapDotYellowNegative.svg';
import dotLightGreen from 'components/icons/svg/mapDotLightGreen.svg';
import dotLightGreenPositive from 'components/icons/svg/mapDotLightGreenPositive.svg';
import dotLightGreenNeutral from 'components/icons/svg/mapDotLightGreenNeutral.svg';
import dotLightGreenNegative from 'components/icons/svg/mapDotLightGreenNegative.svg';
import dotGreen from 'components/icons/svg/mapDotGreen.svg';
import dotGreenPositive from 'components/icons/svg/mapDotGreenPositive.svg';
import dotGreenNeutral from 'components/icons/svg/mapDotGreenNeutral.svg';
import dotGreenNegative from 'components/icons/svg/mapDotGreenNegative.svg';
import dot from 'components/icons/svg/mapDot.svg';
import dotPositive from 'components/icons/svg/mapDotPositive.svg';
import dotNeutral from 'components/icons/svg/mapDotNeutral.svg';
import dotNegative from 'components/icons/svg/mapDotNegative.svg';
import dotGrey from 'components/icons/svg/mapDotGrey.svg';

export const MAP_ICONS: Record<string, string> = {
	dotRed,
	dotRedPositive,
	dotRedNeutral,
	dotRedNegative,
	dotYellow,
	dotYellowPositive,
	dotYellowNeutral,
	dotYellowNegative,
	dotLightGreen,
	dotLightGreenPositive,
	dotLightGreenNeutral,
	dotLightGreenNegative,
	dotGreen,
	dotGreenPositive,
	dotGreenNeutral,
	dotGreenNegative,
	dot,
	dotPositive,
	dotNeutral,
	dotNegative,
	dotGrey,
};

export const MAP_ICONS_NAMES = {
	dotRed: 'dotRed',
	dotYellow: 'dotYellow',
	dot: 'dot',
	dotLightGreen: 'dotLightGreen',
	dotGreen: 'dotGreen',
	negative: 'Negative',
	positive: 'Positive',
	neutral: 'Neutral',
	dotGrey: 'dotGrey',
};
